import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "card-title fs-4" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge rounded-pill badge-soft-danger fs-6" }, "Vencida")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3 col-4" }
const _hoisted_9 = { class: "col-md-3 col-8 fw-bold fs-5" }
const _hoisted_10 = { class: "col-md-3 col-4" }
const _hoisted_11 = { class: "col-md-3 col-8" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "badge rounded-pill badge-soft-success" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check" }, null, -1)
const _hoisted_15 = { class: "d-grid gap-2 d-sm-block" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document" }, null, -1)
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "text-muted fst-italic"
}



//services
import * as clienteService from "@/services/clienteService";
import storeControle from "@/utils/storeControle";

import { f2dec, fdata, fdataHora, fDifData } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import imgSemImagem from "@/assets/images/sem-imagem.gif";

import config from "@/app.config.json";

interface IProps {
    parcela: clienteService.Mensalidade;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Parcela',
  props: {
    parcela: {}
  },
  setup(__props: any) {

//vue
var props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, "Vencimento " + _toDisplayString(_unref(fdata)(_ctx.parcela.dataVencimento)), 1),
      (_unref(fDifData)(_ctx.parcela.dataVencimento, new Date()) < 0 && _ctx.parcela.dataPagamento == null && _ctx.parcela.situacao != 'Baixado' && _ctx.parcela.boletoId != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, "Parcela: " + _toDisplayString(_ctx.parcela.parcela), 1),
        _createElementVNode("div", _hoisted_9, "Valor R$: " + _toDisplayString(_unref(f2dec)(_ctx.parcela.valor)), 1),
        _createElementVNode("div", _hoisted_10, "Contrato: " + _toDisplayString(_ctx.parcela.contratoId), 1),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.parcela.dataPagamento != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createTextVNode(" Pago em: " + _toDisplayString(_unref(fdata)(_ctx.parcela.dataPagamento)) + " ", 1),
                  _hoisted_14
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.parcela.boletoAntigo && _ctx.parcela.boletoId != null)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "btn btn-success",
                        href: `${_unref(config).urlApi}/Boletos/VerAntigo/${_ctx.parcela.boletoId}`,
                        target: "_blank"
                      }, [
                        _hoisted_17,
                        _createTextVNode(" Ver Boleto ")
                      ], 8, _hoisted_16))
                    : _createCommentVNode("", true),
                  (!_ctx.parcela.boletoAntigo && _ctx.parcela.boletoId != null)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "btn btn-primary",
                        href: `${_unref(config).urlApi}/Boletos/Ver/${_ctx.parcela.boletoId}`,
                        target: "_blank"
                      }, [
                        _hoisted_19,
                        _createTextVNode(" Ver Boleto ")
                      ], 8, _hoisted_18))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.parcela.boletoId == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Boleto ainda não disponível "))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ])
    ])
  ]))
}
}

})